import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
    path: '/login',
    component: () => import('../views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('../views/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('../views/home/index'),
      meta: {
        title: '首页',
        icon: 'home'
      }
    }]
  }
]
export const asyncRouterMap = [{
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {
      title: '商品管理',
      icon: 'product'
    },
    children: [{
        path: 'product',
        name: 'product',
        component: () => import('@/views/pms/product/index'),
        meta: {
          perms: ['pms:product:list'],
          title: '商品列表',
          icon: 'product-list'
        }
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {
          perms: ['pms:product:create'],
          title: '添加商品',
          icon: 'product-add'
        }
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {
          perms: ['pms:product:update'],
          title: '修改商品',
          icon: 'product-add'
        },
        hidden: true
      },
      {
        path: 'productDetail',
        name: 'productDetail',
        component: () => import('@/views/pms/product/productDetail'),
        meta: {
          perms: ['pms:product:read'],
          title: '商品详情'
        },
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {
          perms: ['pms:productCategory:list'],
          title: '商品分类',
          icon: 'product-cate'
        }
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {
          perms: ['pms:productCategory:create'],
          title: '添加商品分类'
        },
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {
          perms: ['pms:productCategory:update'],
          title: '修改商品分类'
        },
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {
          perms: ['pms:productAttribute:list'],
          title: '商品属性',
          icon: 'product-attr'
        }
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {
          perms: ['pms:productAttribute:list'],
          title: '商品属性列表'
        },
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {
          perms: ['pms:productAttribute:create'],
          title: '添加商品属性'
        },
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {
          perms: ['pms:productAttribute:update'],
          title: '修改商品属性'
        },
        hidden: true
      },
      {
        path: 'productComment',
        name: 'productComment',
        component: () => import('@/views/pms/productComment/index'),
        meta: {
          perms: ['pms:comment:list'],
          title: '评价管理',
          icon: 'product-comment'
        }
      },
      {
        path: 'pCommentDetail',
        name: 'pCommentDetail',
        component: () => import('@/views/pms/productComment/pCommentDetail'),
        meta: {
          perms: ['pms:comment:read'],
          title: '评价详情'
        },
        hidden: true
      },
      {
        path: 'pCommentReply',
        name: 'pCommentReply',
        component: () => import('@/views/pms/productComment/pCommentReply'),
        meta: {
          perms: ['pms:commentReplay:list'],
          title: '回复评价'
        },
        hidden: true
      },
      {
        path: 'freight',
        name: 'freight',
        component: () => import('@/views/pms/freight/index'),
        meta: {
          perms: ['pms:feightTemplate:list'],
          title: '运费模板',
          icon: 'freight'
        }
      },
      {
        path: 'addFreight',
        name: 'addFreight',
        component: () => import('@/views/pms/freight/addFreight'),
        meta: {
          perms: ['pms:feightTemplate:create'],
          title: '新增运费模块'
        },
        hidden: true
      },
      {
        path: 'editFreight',
        name: 'editFreight',
        component: () => import('@/views/pms/freight/editFreight'),
        meta: {
          perms: ['pms:feightTemplate:update'],
          title: '修改运费模块'
        },
        hidden: true
      },
      {
        path: 'picLibrary',
        name: 'picLibrary',
        component: () => import('@/views/pms/picLibrary/index'),
        meta: {
          perms: ['pms:picLibrary:list'],
          title: '图片库',
          icon: 'pm-tubiao'
        }
      },
      {
        path: 'inventory',
        name: 'inventory',
        component: () => import('@/views/pms/inventory/inventoryList'),
        meta: {
          perms: ['pms:inventoryList:list'],
          title: '商品库存列表',
          icon: 'pm-tubiao'
        }
      },
      {
        path: 'inventoryLogList',
        name: 'inventoryLogList',
        component: () => import('@/views/pms/inventory/inventoryLogList'),
        meta: {
          perms: ['pms:inventoryLogList:list'],
          title: '商品库存日志列表',
          icon: 'pm-tubiao'
        },
        hidden: true
      },
      {
        path: 'picDetail',
        name: 'picDetail',
        component: () => import('@/views/pms/picLibrary/picDetail'),
        meta: {
          perms: ['pms:picLibrary:read'],
          title: '图片库'
        },
        hidden: true
      },
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {
      title: '订单管理',
      icon: 'order'
    },
    children: [{
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {
          perms: ['oms:order:list'],
          title: '订单列表',
          icon: 'oms-list'
        }
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {
          perms: ['oms:order:read'],
          title: '订单详情'
        },
        hidden: true
      },
      {
        path: 'logistics',
        name: 'logistics',
        component: () => import('@/views/oms/order/logistics'),
        meta: {
          perms: ['oms:logistics:read'],
          title: '物流详情'
        },
        hidden: true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {
          perms: ['oms:orderSetting:read'],
          title: '订单设置',
          icon: 'order-setting'
        }
      },
      {
        path: 'expressCompanyList',
        name: 'expressCompanyList',
        component: () => import('@/views/oms/order/expressCompanyList'),
        meta: {
          perms: ['oms:expressCompanyList:list'],
          title: '快递公司列表',
          icon: 'oms-company'
        }
      },
    ]
  },
  {
    path: '/mms',
    component: Layout,
    redirect: '/mms/memberList',
    name: 'mms',
    meta: {
      title: '会员管理',
      icon: 'mms'
    },
    children: [{
        path: 'memberList',
        name: 'memberList',
        component: () => import('@/views/mms/memberList/index'),
        meta: {
          perms: ['mms:memberList:list'],
          title: '会员列表',
          icon: 'mms-list'
        }
      },
      {
        path: 'memberDetail',
        name: 'memberDetail',
        component: () => import('@/views/mms/memberList/memberDetail'),
        meta: {
          perms: ['mms:memberDetail:read'],
          title: '会员详情'
        },
        hidden: true
      },
      {
        path: 'analysisMember',
        name: 'analysisMember',
        component: () => import('@/views/mms/analysisMember/index'),
        meta: {
          perms: ['mms:analysisMember:read'],
          title: '会员统计',
          icon: 'mms-analysis'
        }
      },
      {
        path: 'viewsHistory',
        name: 'viewsHistory',
        component: () => import('@/views/mms/History/views'),
        meta: {
          perms: ['mms:viewsHistory:list'],
          title: '会员浏览记录'
        },
        hidden: true
      },
      {
        path: 'collectHistory',
        name: 'collectHistory',
        component: () => import('@/views/mms/history/collect'),
        meta: {
          perms: ['mms:collectHistory:list'],
          title: '会员收藏记录'
        },
        hidden: true
      },
      {
        path: 'dealersList',
        name: 'dealersList',
        component: () => import('@/views/mms/dealers/index'),
        meta: {
          perms: ['mms:dealersList:list'],
          title: '经销商会员列表',
          icon: 'mms-list'
        }
      },
      {
        path: 'addDealers',
        name: 'addDealers',
        component: () => import('@/views/mms/dealers/add'),
        meta: {
          perms: ['mms:addDealers:add'],
          title: '添加经销商会员'
        },
        hidden: true
      },
      {
        path: 'editDealers',
        name: 'editDealers',
        component: () => import('@/views/mms/dealers/update'),
        meta: {
          perms: ['mms:editDealers:edit'],
          title: '编辑经销商会员'
        },
        hidden: true
      },
      {
        path: 'dealersDetail',
        name: 'dealersDetail',
        component: () => import('@/views/mms/dealers/nextLevelTradeDetail'),
        meta: {
          perms: ['mms:dealersDetail:detail'],
          title: '经销商下级交易统计'
        },
        hidden: true
      },
      // {
      //   path: 'checkList',
      //   name: 'checkList',
      //   component: () => import('@/views/mms/dealers/checkList'),
      //   meta: {
      //     perms: ['mms:checkList:list'],
      //     title: '经销商下级会员审核列表',
      //     icon: 'mms-list'
      //   }
      // },
      {
        path: 'nextMemberList',
        name: 'nextMemberList',
        component: () => import('@/views/mms/dealers/nextLevel'),
        meta: {
          perms: ['mms:nextMemberList:list'],
          title: '经销商下级会员列表',
          icon: 'mms-list'
        }
      },
      {
        path: 'straightList',
        name: 'straightList',
        component: () => import('@/views/mms/straight/index'),
        meta: {
          perms: ['mms:straightList:list'],
          title: '厂家直供会员列表',
          icon: 'mms-list'
        }
      },
      {
        path: 'addStraight',
        name: 'addStraight',
        component: () => import('@/views/mms/straight/add'),
        meta: {
          perms: ['mms:addStraight:add'],
          title: '添加厂家直供会员'
        },
        hidden: true
      },
      {
        path: 'editStraight',
        name: 'editStraight',
        component: () => import('@/views/mms/straight/update'),
        meta: {
          perms: ['mms:editStraight:edit'],
          title: '编辑厂家直供会员'
        },
        hidden: true
      },
    ]
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {
      title: "营销管理",
      icon: "sms"
    },
    children: [{
        path: "advertise",
        name: "homeAdvertise",
        component: () => import("@/views/sms/advertise/index"),
        meta: {
          perms: ["sms:advertise:list"],
          title: "广告列表",
          icon: "sms-ad"
        }
      },
      {
        path: "addAdvertise",
        name: "addHomeAdvertise",
        component: () => import("@/views/sms/advertise/add"),
        meta: {
          perms: ["sms:addAdvertise:create"],
          title: "添加广告"
        },
        hidden: true
      },
      {
        path: "updateAdvertise",
        name: "updateHomeAdvertise",
        component: () => import("@/views/sms/advertise/update"),
        meta: {
          perms: ["sms:updateAdvertise:update"],
          title: "编辑广告"
        },
        hidden: true
      },
      {
        path: "navigation",
        name: "navigation",
        component: () => import("@/views/sms/navigation/index"),
        meta: {
          perms: ["sms:navigation:list"],
          title: "导航栏列表",
          icon: "sms-nav"
        }
      },
      {
        path: "addNavigation",
        name: "addNavigation",
        component: () => import("@/views/sms/navigation/add"),
        meta: {
          perms: ["sms:addNavigation:create"],
          title: "添加导航"
        },
        hidden: true
      },
      {
        path: "editNavigation",
        name: "editNavigation",
        component: () => import("@/views/sms/navigation/edit"),
        meta: {
          perms: ["sms:editNavigation:update"],
          title: "编辑导航"
        },
        hidden: true
      },
      {
        path: "subject",
        name: "homeSubject",
        component: () => import("@/views/sms/subject/index"),
        meta: {
          perms: ["sms:homeSubject:list"],
          title: "专题列表",
          icon: "sms-subject"
        }
      },
      {
        path: "addSubject",
        name: "addSubject",
        component: () => import("@/views/sms/subject/add"),
        meta: {
          perms: ["sms:addSubject:create"],
          title: "添加专题"
        },
        hidden: true
      },
      {
        path: "editSubject",
        name: "editSubject",
        component: () => import("@/views/sms/subject/edit"),
        meta: {
          perms: ["sms:editSubject:update"],
          title: "编辑专题"
        },
        hidden: true
      },
      {
        path: "setSubject",
        name: "setSubject",
        component: () => import("@/views/sms/subject/set"),
        meta: {
          perms: ["sms:setSubject:list"],
          title: "设置商品"
        },
        hidden: true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {
          perms: ["sms:couponList:list"],
          title: '优惠券列表',
          icon: 'sms-coupon'
        }
      },
      {
        path: 'counpDetail',
        name: 'counpDetail',
        component: () => import('@/views/sms/coupon/counpDetail'),
        meta: {
          perms: ["sms:couponActiveList:list"],
          title: '优惠券活动列表',
          icon: 'sms-coupon'
        },
        hidden: true
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {
          perms: ["sms:addcoupon:list"],
          title: '添加优惠券'
        },
        hidden: true
      },
      {
        path: 'editCoupon',
        name: 'editCoupon',
        component: () => import('@/views/sms/coupon/edit'),
        meta: {
          perms: ["sms:editcoupont:list"],
          title: '编辑优惠券'
        },
        hidden: true
      },
      {
        path: 'fullreductionList',
        name: 'fullreductionList',
        component: () => import('@/views/sms/fullReduction/index'),
        meta: {
          perms: ["sms:fullreductionList:list"],
          title: '满减活动列表',
          icon: 'sms-coupon'
        }
      },
      {
        path: 'addFullreduction',
        name: 'addFullreduction',
        component: () => import('@/views/sms/fullReduction/add'),
        meta: {
          perms: ["sms:addFullreduction:add"],
          title: '添加满减活动'
        },
        hidden: true
      },
      {
        path: 'editFullreduction',
        name: 'editFullreduction',
        component: () => import('@/views/sms/fullReduction/edit'),
        meta: {
          perms: ["sms:editFullreduction:edit"],
          title: '编辑满减活动'
        },
        hidden: true
      },
    ]
  },
  {
    path: '/sta',
    component: Layout,
    redirect: '/sta/proStatistical',
    name: 'sta',
    meta: {
      title: '统计管理',
      icon: 'sms'
    },
    alwaysShow: true,
    children: [{
        path: 'proStatistical',
        name: 'proStatistical',
        component: () => import('@/views/sta/pro/index'),
        meta: {
          perms: ['cms:proStatistical:list'],
          title: '商品统计数据',
          icon: 'mms-list'
        }
      },
      {
        path: 'tradeStatistical',
        name: 'tradeStatistical',
        component: () => import('@/views/sta/trade/index'),
        meta: {
          perms: ['cms:tradeStatistical:list'],
          title: '订单统计数据',
          icon: 'mms-list'
        }
      },
    ]
  },
  {
    path: '/cms',
    component: Layout,
    redirect: '/cms/questionList',
    name: 'cms',
    meta: {
      title: '内容管理',
      icon: 'cms'
    },
    children: [{
        path: 'questionList',
        name: 'questionList',
        component: () => import('@/views/cms/questionList/index'),
        meta: {
          perms: ['cms:questionList:list'],
          title: '常见问题',
          icon: 'cms-question'
        }
      },
      {
        path: 'addQuestion',
        name: 'addQuestion',
        component: () => import('@/views/cms/questionList/addQuestion'),
        meta: {
          perms: ['cms:addQuestion:create'],
          title: '添加问题'
        },
        hidden: true
      },
      {
        path: 'editQuestion',
        name: 'editQuestion',
        component: () => import('@/views/cms/questionList/editQuestion'),
        meta: {
          perms: ['cms:editQuestion:update'],
          title: '编辑问题'
        },
        hidden: true
      },
      {
        path: 'areaManage',
        name: 'areaManage',
        component: () => import('@/views/cms/areaManage/index'),
        meta: {
          perms: ['cms:areaManage:list'],
          title: '区域管理',
          icon: 'cms-area'
        }
      },
      {
        path: 'informationCate',
        name: 'informationCate',
        component: () => import('@/views/cms/information/productCate/index'),
        meta: {
          perms: ['cms:informationCate:list'],
          title: '资讯公告分类列表',
          icon: 'product-cate'
        }
      },
      {
        path: 'addInformationCate',
        name: 'addInformationCate',
        component: () => import('@/views/cms/information/productCate/add'),
        meta: {
          perms: ['cms:addInformationCate:add'],
          title: '添加资讯公告分类'
        },
        hidden: true
      },
      {
        path: 'updateInformationCate',
        name: 'updateInformationCate',
        component: () => import('@/views/cms/information/productCate/update'),
        meta: {
          perms: ['cms:updateInformationCate:edit'],
          title: '修改资讯公告分类'
        },
        hidden: true
      },
      {
        path: 'information',
        name: 'information',
        component: () => import('@/views/cms/information/index'),
        meta: {
          perms: ['cms:information:list'],
          title: '资讯公告列表',
          icon: 'product-list'
        }
      },
      {
        path: 'addInformation',
        name: 'addInformation',
        component: () => import('@/views/cms/information/add'),
        meta: {
          perms: ['cms:addInformation:add'],
          title: '添加资讯公告',
          icon: 'product-add'
        },
        hidden: true
      },
      {
        path: 'updateInformation',
        name: 'updateInformation',
        component: () => import('@/views/cms/information/edit'),
        meta: {
          perms: ['cms:updateInformation:edit'],
          title: '修改资讯公告',
          icon: 'product-add'
        },
        hidden: true
      },
      {
        path: 'leaveMessageList',
        name: 'leaveMessageList',
        component: () => import('@/views/cms/leaveMessage/index'),
        meta: {
          perms: ['cms:leaveMessageList:list'],
          title: '展会留言列表',
          icon: 'product-list'
        }
      },
      {
        path: 'feedbackList',
        name: 'feedbackList',
        component: () => import('@/views/cms/feedback/index'),
        meta: {
          perms: ['cms:feedbackList:list'],
          title: '意见反馈列表',
          icon: 'product-list'
        }
      },
      {
        path: 'setCenter',
        name: 'setCenter',
        component: () => import('@/views/cms/setCenter/add'),
        meta: {
          perms: ['cms:areaManage:list'],
          title: '商城设置',
          icon: 'cms-area'
        }
      },
    ]
  },
  {
    path: '/am',
    component: Layout,
    redirect: '/am/administrators',
    name: 'am',
    meta: {
      title: '权限安全',
      icon: 'am'
    },
    children: [{
        path: 'department',
        name: 'department',
        component: () => import('@/views/am/department/department'),
        meta: {
          perms: ['am:department:list'],
          title: '部门管理',
          icon: 'am-bumen'
        }
      },
      {
        path: 'departmentJurisdiction',
        name: 'departmentJurisdiction',
        component: () => import('@/views/am/department/departmentJurisdiction'),
        meta: {
          perms: ['am:departmentJurisdiction:read'],
          title: '部门权限',
          icon: 'sms-flash'
        },
        hidden: true
      },
      {
        path: 'operation',
        name: 'operation',
        component: () => import('@/views/am/administrators/operation'),
        meta: {
          perms: ['am:operation:list'],
          title: '管理员操作',
          icon: 'am-guanli'
        }
      },
      {
        path: 'permissionList',
        name: 'permissionList',
        component: () => import('@/views/am/permission/index'),
        meta: {
          perms: ['am:department:list'],
          title: '权限列表',
          icon: 'am-bumen'
        }
      },
      {
        path: 'jurisdictionList',
        name: 'jurisdictionList',
        component: () => import('@/views/am/administrators/jurisdictionList'),
        meta: {
          perms: ['am:jurisdictionList:list'],
          title: '操作日志',
          icon: 'am-diary'
        }
      }
    ]
  },


  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]


export default new Router({
  mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [...constantRouterMap]
})



// WEBPACK FOOTER //
// ./src/router/index.js